import ContractorsFooter from "./ContractorsFooter";

export default ContractorsFooter;
